<template>
  <footer class="container footer">
    <div class="row">
      <div class="col-md-3">

      </div>
      <div class="col-md-6">
        <p class="mb-md-0 mb-0">We are dedicated to protecting your private information. </p>
        <a role="button" class="footer__link">Click here to learn more about information protection</a>
      </div>
      <div class="col-md-3">
        <a role="button" class="footer__link">Help and Support</a>
        <a role="button" class="footer__link">Terms & Conditions</a>
        <a role="button" class="footer__link" >Privacy Policy</a>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "FooterBar"
  }
</script>

<style scoped lang="scss">
  $color-base: #0060ff;

  .footer {
    max-width: 100%;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    background-color: $color-base;
    color: #fff;
    font-size: 0.8rem;
    text-align: center;
    
    .footer__link {
      display: block;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    position: absolute;
    bottom: 0;
  }

</style>